<ng-container screenAnalytics="mission-details-v2">
    <div class="modal-header">
        <div class="panel-heading-icon">
            <img imgPath="/icons/icon-missions.png" />
        </div>
        <h3 class="modal-title">
            View Mission
            {{ mission?.status === 'COMPLETED' ? 'Record' : 'Plan' }}
        </h3>
        <h5 class="modal-title padding">
            Details
            {{
                mission?.readyForFinalisation && mission?.status !== 'FINALISED'
                    ? '(Awaiting finalisation)'
                    : ''
            }}
        </h5>
        <knowledge-base-link></knowledge-base-link>
        <button
            type="button"
            (click)="modal.hide()"
            aria-label="Close"
            class="close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <form name="missionDetailsForm" class="relative">
        <ngx-loading
            [show]="working || modalStatus === 'LOADING'"
        ></ngx-loading>
        <error-overlay
            [status]="modalStatus"
            [noun]="'mission'"
            [show]="modalStatus === 'NO_ACCESS' || modalStatus === 'NOT_FOUND'"
        ></error-overlay>
        <div
            *ngIf="
                missionDetailsService.organisation$
                    | async as currentOrganisation
            "
            class="modal-body"
            [ngClass]="{ 'no-footer': modalStatus !== 'LOADED' }"
        >
            <ng-container *ngIf="modalStatus === 'LOADED'">
                <div class="modal-content-full-width">
                    <summary-header
                        [mission]="mission"
                        [organisation]="currentOrganisation"
                        [missionApprovals]="missionApprovals"
                        [working]="working"
                    >
                    </summary-header>
                    <div class="mission-details-status">
                        <mission-details-status
                            [mission]="mission"
                            [organisation]="currentOrganisation"
                            [missionApprovals]="missionApprovals"
                            (openConformanceTab)="openConformanceTab()"
                            (cancelApproval)="cancelApproval($event)"
                            (requestPerformApproval)="
                                findApprovalAndApprove($event)
                            "
                            (requestCancelApproval)="cancelApproval($event)"
                            #missionRibbons
                        ></mission-details-status>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-5 mission-info">
                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Name:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.name }}
                            </div>
                        </div>
                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                UID:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.uid }}
                            </div>
                        </div>
                        <!-- <div class="row top-buffer">
                        <div class="col-xs-12 col-sm-3 display-label">Status:</div>
                        <div class="col-xs-12 col-sm-9">{{ $ctrl.mission.status | formatCombinedMissionStatus }}</div>
                    </div> -->
                        <div
                            class="row top-buffer"
                            *ngIf="mission != null && mission.project != null"
                        >
                            <div class="col-xs-12 col-sm-3 display-label">
                                Project:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.project?.name }}
                            </div>
                        </div>

                        <div
                            class="row top-buffer"
                            *ngIf="mission != null && mission.workgroup != null"
                        >
                            <div class="col-xs-12 col-sm-3 display-label">
                                Workgroup:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.workgroup?.name }}
                            </div>
                        </div>
                        <div
                            class="row top-buffer"
                            *ngIf="
                                mission != null &&
                                mission.missionObjectiveType != null
                            "
                        >
                            <div class="col-xs-12 col-sm-3 display-label">
                                Objective:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.missionObjectiveType?.name }}
                            </div>
                        </div>
                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Objective Description:
                            </div>
                            <div class="col-xs-12 col-sm-9 pre-line">
                                {{ mission?.missionObjective }}
                            </div>
                        </div>
                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Crew Notes:
                            </div>
                            <div class="col-xs-12 col-sm-9 pre-line">
                                {{ mission?.crewNotes }}
                            </div>
                        </div>
                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Date/Time:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ missionDate | formatDateTime }}
                            </div>
                        </div>
                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Time of Day:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.timeOfDay }}
                            </div>
                        </div>
                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Visual Line of Sight:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.visualLineOfSight }}
                            </div>
                        </div>
                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Estimated Duration:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{
                                    mission?.missionEstimatedTime
                                        | formatDuration
                                }}
                            </div>
                        </div>

                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Operation Type:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.missionType?.name }}
                            </div>
                        </div>

                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Mission Type:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.type | formatMissionType }}
                            </div>
                        </div>

                        <div
                            *ngIf="mission?.pointOfContact"
                            class="row top-buffer"
                        >
                            <div class="col-xs-12 col-sm-3 display-label">
                                Point of Contact:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.pointOfContact }}
                                :
                                {{ mission?.pointOfContactInformation }}
                            </div>
                        </div>

                        <ng-container
                            *ngIf="
                                missionDetails != null && canViewOrganisation
                            "
                        >
                            <div
                                class="row top-buffer"
                                *ngIf="canEditFieldAppOperator"
                            >
                                <div class="col-xs-12 col-sm-10"></div>
                                <div
                                    class="col-xs-12 col-sm-2 text-center display-label"
                                >
                                    Field App Operator
                                </div>
                            </div>
                            <div
                                class="row top-buffer"
                                [ngClass]="{
                                    error: missionDetails.rpic == null
                                }"
                            >
                                <div class="col-xs-12 col-sm-3 display-label">
                                    Remote Pilot In Command:
                                </div>
                                <div
                                    [class]="
                                        canEditFieldAppOperator
                                            ? 'col-xs-12 col-sm-7'
                                            : 'col-xs-12 col-sm-9'
                                    "
                                >
                                    <div class="wrap">
                                        <a
                                            (click)="
                                                showPilot(missionDetails.rpic)
                                            "
                                            *ngIf="
                                                missionDetails.rpic != null &&
                                                canViewOrganisation
                                            "
                                        >
                                            {{
                                                missionDetails.rpic
                                                    | formatPerson
                                            }}
                                            #
                                            {{
                                                missionDetails.rpic
                                                    .activeJurisdictions
                                                    | formatJurisdictionAuthorityIdentifier
                                                        : airspaceJurisdictionId
                                            }}
                                        </a>
                                        <span
                                            *ngIf="
                                                missionDetails.rpic != null &&
                                                !canViewOrganisation
                                            "
                                        >
                                            {{
                                                missionDetails.rpic
                                                    | formatPerson
                                            }}
                                            #
                                            {{
                                                missionDetails.rpic
                                                    .activeJurisdictions
                                                    | formatJurisdictionAuthorityIdentifier
                                                        : airspaceJurisdictionId
                                            }}
                                        </span>
                                    </div>
                                </div>
                                <div
                                    class="col-xs-12 col-sm-2 text-center"
                                    *ngIf="canEditFieldAppOperator"
                                >
                                    <input
                                        type="radio"
                                        name="fieldAppOperator"
                                        [checked]="fieldAppOperatorId === null"
                                        (change)="updateFieldAppOperator()"
                                    />
                                </div>
                            </div>
                            <div
                                class="row top-buffer"
                                *ngIf="!canEditFieldAppOperator"
                            >
                                <div class="col-xs-12 col-sm-3 display-label">
                                    Additional Crew:
                                </div>
                                <div class="col-xs-12 col-sm-9">
                                    <div
                                        class="wrap"
                                        *ngIf="
                                            missionDetails.additionalCrew
                                                .length > 0
                                        "
                                    >
                                        <span
                                            *ngFor="
                                                let crew of missionDetails.additionalCrew;
                                                let last = last
                                            "
                                        >
                                            <a
                                                *ngIf="canViewOrganisation"
                                                (click)="showPilot(crew.person)"
                                            >
                                                {{ crew.person | formatPerson }}
                                                #{{ crew.person.arn }}
                                            </a>
                                            <ng-container
                                                *ngIf="!canViewOrganisation"
                                            >
                                                {{ crew.person | formatPerson }}
                                                #{{ crew.person.arn }}
                                            </ng-container>
                                            ({{ crew.role.name }})
                                            {{ !last ? ',' : '' }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <ng-container *ngIf="canEditFieldAppOperator">
                                <div
                                    class="row top-buffer"
                                    *ngFor="
                                        let crew of missionDetails.additionalCrew;
                                        let first = first
                                    "
                                >
                                    <div
                                        class="col-xs-12 col-sm-3 display-label"
                                    >
                                        {{ first ? 'Additional Crew:' : '' }}
                                    </div>
                                    <div class="col-xs-12 col-sm-7">
                                        <div class="wrap">
                                            <a
                                                *ngIf="canViewOrganisation"
                                                (click)="showPilot(crew.person)"
                                            >
                                                {{ crew.person | formatPerson }}
                                                #{{ crew.person.arn }}
                                            </a>

                                            <ng-container
                                                *ngIf="!canViewOrganisation"
                                            >
                                                {{ crew.person | formatPerson }}
                                                #{{ crew.person.arn }}
                                            </ng-container>
                                            ({{ crew.role.name }})
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-2 text-center">
                                        <input
                                            type="radio"
                                            name="fieldAppOperator"
                                            [checked]="
                                                fieldAppOperatorId ===
                                                crew.person.id
                                            "
                                            (change)="
                                                updateFieldAppOperator(
                                                    crew.person.id
                                                )
                                            "
                                        />
                                    </div>
                                </div>
                            </ng-container>

                            <div class="row top-buffer">
                                <div
                                    class="col-xs-12 col-sm-3 display-label"
                                    [ngClass]="{
                                        error: mission.crafts.length === 0
                                    }"
                                >
                                    RPA:
                                </div>
                                <div class="col-xs-12 col-sm-9">
                                    <div
                                        class="wrap"
                                        *ngIf="mission.crafts.length > 0"
                                    >
                                        <span
                                            *ngFor="
                                                let craft of mission.crafts;
                                                let last = last
                                            "
                                        >
                                            <a
                                                *ngIf="canViewOrganisation"
                                                (click)="showCraft(craft)"
                                            >
                                                {{ craft | formatRpa
                                                }}{{ !last ? ', ' : '' }}
                                            </a>
                                            <ng-container
                                                *ngIf="!canViewOrganisation"
                                            >
                                                {{ craft | formatRpa
                                                }}{{ !last ? ', ' : '' }}
                                            </ng-container>
                                            <span
                                                class="status"
                                                [ngClass]="
                                                    craft.status
                                                        | rpaStatusClass
                                                "
                                            >
                                                {{
                                                    craft.status
                                                        | formatResourceStatus
                                                }}
                                            </span>
                                        </span>
                                        <!-- <span>Insurance</span> -->
                                    </div>
                                </div>
                            </div>
                            <div class="row top-buffer" *ngIf="canUseEquipment">
                                <div
                                    class="col-xs-12 col-sm-3 display-label"
                                    [ngClass]="{
                                        error: mission.crafts.length === 0
                                    }"
                                >
                                    Equipment:
                                </div>
                                <div class="col-xs-12 col-sm-9">
                                    <div
                                        class="wrap"
                                        *ngIf="mission.equipment.length > 0"
                                    >
                                        <span
                                            *ngFor="
                                                let equipment of mission.equipment;
                                                let last = last
                                            "
                                        >
                                            <a
                                                *ngIf="canViewOrganisation"
                                                (click)="
                                                    showEquipment(equipment)
                                                "
                                            >
                                                {{ equipment.name
                                                }}{{ !last ? ', ' : '' }}
                                            </a>
                                            <ng-container
                                                *ngIf="!canViewOrganisation"
                                            >
                                                {{ equipment.name
                                                }}{{ !last ? ', ' : '' }}
                                            </ng-container>
                                            <span
                                                class="status"
                                                [ngClass]="
                                                    equipment.status
                                                        | equipmentStatusClass
                                                "
                                            >
                                                {{
                                                    equipment.status
                                                        | formatResourceStatus
                                                }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="row top-buffer"
                                [ngClass]="{ error: mission.location == null }"
                            >
                                <div class="col-xs-12 col-sm-3 display-label">
                                    Location:
                                </div>
                                <div class="col-xs-12 col-sm-9">
                                    {{ mission?.location?.name }}
                                </div>
                            </div>
                        </ng-container>
                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Planned Max Height:
                            </div>
                            <div class="col-xs-12 col-sm-9">
                                {{ mission?.maximumHeight }} ft (AGL)
                            </div>
                        </div>

                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Important Contacts:
                            </div>
                            <div
                                *ngIf="mission.modelVersion === 1"
                                class="col-xs-12 col-sm-9 pre-line"
                                [innerHtml]="mission?.emergencyContacts"
                            ></div>
                            <div
                                *ngIf="mission.modelVersion === 2"
                                class="col-xs-12 col-sm-9 pre-line"
                            >
                                <mission-contact
                                    *ngFor="
                                        let contact of mission.missionContacts
                                    "
                                    [contact]="contact"
                                ></mission-contact>
                            </div>
                        </div>

                        <div class="row top-buffer">
                            <div class="col-xs-12 col-sm-3 display-label">
                                Radio Frequencies:
                            </div>
                            <div
                                *ngIf="mission.modelVersion === 1"
                                class="col-xs-12 col-sm-9"
                            >
                                {{ mission?.radioFrequencies }}
                            </div>
                            <div
                                *ngIf="mission.modelVersion === 2"
                                class="col-xs-12 col-sm-9 pre-line"
                            >
                                <mission-contact
                                    *ngFor="
                                        let contact of mission.missionRadioFrequencies
                                    "
                                    [contact]="contact"
                                ></mission-contact>
                            </div>
                        </div>

                        <!-- <div class="row top-buffer">
                        <div class="col-xs-12 col-sm-3 display-label">Weather:</div>
                        <div
                            class="col-xs-12 col-sm-9"
                            ng-bind-html="$ctrl.mission.weather | formatWeather"></div>
                    </div> -->
                    </div>
                    <div class="col-xs-12 col-md-7">
                        <tabset *ngIf="missionDetails != null" #tabset>
                            <tab *ngIf="true" heading="Flight Area">
                                <flyfreely-map
                                    *ngIf="
                                        locationFeatures != null &&
                                        tabset.tabs[0].active === true
                                    "
                                    #map
                                    siteBoundaries
                                    externalMissions
                                    style="height: 500px"
                                    [organisationId]="currentOrganisation.id"
                                    [features]="locationFeatures"
                                    featuresTitle="Flights"
                                    [showFeatureSelection]="true"
                                    [requireCtrlToZoom]="true"
                                    [startTime]="missionStartTime"
                                    [endTime]="missionEndTime"
                                    [ruleset]="missionRuleset"
                                    [mapSourceFilters]="mapSourceFilters"
                                    [enabledLayerGroups]="enabledMapLayerGroups"
                                    [mapData]="mapData$ | async"
                                    [enableLayerGroupsByDefault]="[
                                        'NOTAM',
                                        'MISSIONS',
                                        'EXTERNAL_MISSIONS'
                                    ]"
                                    (fullscreenRequested)="
                                        onFullscreenRequested()
                                    "
                                    (featuresLoaded)="
                                        map.zoomToAllFeatures(true)
                                    "
                                ></flyfreely-map>
                                <p *ngIf="locationFeatures == null">
                                    No flight area defined
                                </p>
                            </tab>
                            <tab
                                *ngIf="
                                    isCompleted || mission.status === 'FLYING'
                                "
                                heading="Mission Log and Flights"
                            >
                                <h4 *ngIf="isCompleted">Mission Outcomes</h4>
                                <div class="row top-buffer" *ngIf="isCompleted">
                                    <div
                                        class="col-xs-12 col-sm-2 display-label"
                                    >
                                        Actual Location:
                                    </div>
                                    <div class="col-xs-12 col-sm-2">
                                        {{
                                            actualLocation
                                                ? actualLocation.name
                                                : ''
                                        }}
                                    </div>
                                    <div
                                        class="col-xs-12 col-sm-2 display-label"
                                    >
                                        Actual Date/Time:
                                    </div>
                                    <div class="col-xs-12 col-sm-2">
                                        <!-- Suppressing the time zone display for spacing and since it should match the main mission details -->
                                        {{
                                            mission?.actualStartTime
                                                | formatDateTime
                                                    : mission.timeZone
                                                    : true
                                        }}
                                    </div>
                                    <div
                                        class="col-xs-12 col-sm-2 display-label"
                                    >
                                        Objective Outcome:
                                    </div>
                                    <div class="col-xs-12 col-sm-2">
                                        {{
                                            mission?.outcome
                                                | formatObjectiveOutcome
                                        }}
                                    </div>
                                </div>
                                <div class="row top-buffer" *ngIf="isCompleted">
                                    <div
                                        class="col-xs-12 col-sm-2 display-label"
                                    >
                                        Objective Outcome Details:
                                    </div>
                                    <div class="col-xs-12 col-sm-10 pre-line">
                                        {{ mission?.objectiveOutcomeNotes }}
                                    </div>
                                </div>
                                <div class="row top-buffer" *ngIf="isCompleted">
                                    <div
                                        class="col-xs-12 col-sm-2 display-label"
                                    >
                                        Mission Journal:
                                    </div>
                                    <div class="col-xs-12 col-sm-10 pre-line">
                                        {{ mission?.completionMessage }}
                                    </div>
                                </div>

                                <h4>Flights</h4>
                                <div class="table-container">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Duration</th>
                                                <th>Flight Status</th>
                                                <th>Reason</th>
                                                <th>Remote Pilot</th>
                                                <th>RPA</th>
                                                <th>Battery Set</th>
                                                <th class="actions"></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <ng-container
                                                *ngFor="
                                                    let days of missionSorties
                                                "
                                            >
                                                <tr
                                                    *ngIf="
                                                        missionSorties.length >
                                                        1
                                                    "
                                                >
                                                    <th colspan="8">
                                                        {{
                                                            days.date
                                                                | formatDate
                                                        }}
                                                    </th>
                                                </tr>
                                                <tr
                                                    *ngFor="
                                                        let sortie of days.flights
                                                    "
                                                >
                                                    <td>{{ sortie.number }}</td>
                                                    <td>
                                                        <ng-container
                                                            [ngSwitch]="
                                                                sortie.durationSource
                                                            "
                                                        >
                                                            <ng-container
                                                                *ngSwitchCase="
                                                                    'MANUAL'
                                                                "
                                                            >
                                                                Manual:
                                                                {{
                                                                    sortie.duration
                                                                        | formatDuration
                                                                            : ''
                                                                }}
                                                            </ng-container>
                                                            <ng-container
                                                                *ngSwitchCase="
                                                                    'TIMER'
                                                                "
                                                            >
                                                                Timer:
                                                                {{
                                                                    sortie.duration
                                                                        | formatDuration
                                                                            : ''
                                                                }}
                                                                <em
                                                                    >({{
                                                                        sortie.recordedStartTime
                                                                            | formatTime
                                                                                : mission.timeZone
                                                                    }}
                                                                    to
                                                                    {{
                                                                        sortie.recordedEndTime
                                                                            | formatTime
                                                                                : mission.timeZone
                                                                    }})</em
                                                                >
                                                            </ng-container>
                                                            <ng-container
                                                                *ngSwitchCase="
                                                                    'LOGS'
                                                                "
                                                            >
                                                                <span
                                                                    [tooltip]="
                                                                        sortie.logTimes
                                                                    "
                                                                    placement="top"
                                                                >
                                                                    Logs:
                                                                    {{
                                                                        sortie.duration
                                                                            | formatDuration
                                                                                : ''
                                                                    }}
                                                                    <em
                                                                        >({{
                                                                            sortie.recordedStartTime
                                                                                | formatTime
                                                                                    : mission.timeZone
                                                                        }}
                                                                        to
                                                                        {{
                                                                            sortie.recordedEndTime
                                                                                | formatTime
                                                                                    : mission.timeZone
                                                                        }})</em
                                                                    >
                                                                </span>
                                                            </ng-container>
                                                        </ng-container>
                                                    </td>
                                                    <td>{{ sortie.status }}</td>
                                                    <td>{{ sortie.reason }}</td>
                                                    <td>
                                                        {{
                                                            personLookup[
                                                                sortie.pilotId
                                                            ] | formatPerson
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            (craftLookup
                                                                ? craftLookup[
                                                                      sortie
                                                                          .craftId
                                                                  ]
                                                                : null
                                                            ) | formatRpa
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            (batterySetLookup
                                                                ? batterySetLookup[
                                                                      sortie
                                                                          .batterySetId
                                                                  ]
                                                                : null
                                                            ) | formatBatterySet
                                                        }}
                                                    </td>
                                                    <td class="actions">
                                                        <button
                                                            type="button"
                                                            class="btn btn-tertiary btn-sm"
                                                            tooltip="View flight documentation"
                                                            [disabled]="working"
                                                            (click)="
                                                                showSortieDocumentation(
                                                                    sortie
                                                                )
                                                            "
                                                        >
                                                            <span
                                                                class="fal fa-paperclip"
                                                            ></span>
                                                        </button>
                                                        <ng-container
                                                            *ngIf="
                                                                hasFlightLogging &&
                                                                flightLogsByFlight !=
                                                                    null
                                                            "
                                                        >
                                                            <button
                                                                *ngIf="
                                                                    flightLogsByFlight[
                                                                        sortie
                                                                            .id
                                                                    ] == null
                                                                "
                                                                tooltip="Analyse flight log"
                                                                type="button"
                                                                class="btn btn-tertiary btn-sm"
                                                                [disabled]="
                                                                    true
                                                                "
                                                            >
                                                                <span
                                                                    class="fal fa-map"
                                                                ></span>
                                                            </button>
                                                            <button
                                                                *ngFor="
                                                                    let flightLog of flightLogsByFlight[
                                                                        sortie
                                                                            .id
                                                                    ];
                                                                    let i = index
                                                                "
                                                                [tooltip]="
                                                                    'Analyse flight log ' +
                                                                    (flightLog
                                                                        .summary
                                                                        ?.startTime
                                                                        | formatDateTime
                                                                            : mission.timeZone)
                                                                "
                                                                type="button"
                                                                class="btn btn-tertiary btn-sm"
                                                                (click)="
                                                                    analyseFlightLog(
                                                                        sortie,
                                                                        flightLog
                                                                    )
                                                                "
                                                            >
                                                                <span
                                                                    class="fal fa-map"
                                                                ></span>
                                                            </button>
                                                        </ng-container>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                                <h4
                                    *ngIf="
                                        unassignedFlightLogs != null &&
                                        unassignedFlightLogs.length > 0
                                    "
                                >
                                    Flight Logs without Flights
                                </h4>
                                <flight-log-list
                                    *ngIf="
                                        unassignedFlightLogs != null &&
                                        unassignedFlightLogs.length > 0
                                    "
                                    [flightLogs]="unassignedFlightLogs"
                                    [rpas]="mission.crafts"
                                    [mission]="mission"
                                ></flight-log-list>
                            </tab>
                            <tab
                                *ngIf="
                                    userCanViewAirspaceAuthorisation &&
                                    showAirspaceAuthorisationStatus &&
                                    (approvedAirspaceAuthorisations != null ||
                                        airspaceLoading)
                                "
                                [heading]="
                                    approvedAirspaceAuthorisations != null &&
                                    approvedAirspaceAuthorisations.length &&
                                    airspaceLoading
                                        ? 'Loading'
                                        : 'Airspace Authorisation'
                                "
                                [disabled]="
                                    approvedAirspaceAuthorisations == null
                                "
                            >
                                <div class="relative" style="height: 280px">
                                    <airspace-authorisation-status
                                        [enabledAuthorisationTypes]="
                                            enabledAuthorisationTypes
                                        "
                                        [jurisdiction]="
                                            location?.airspaceJurisdiction
                                        "
                                        [isMissionDetailsView]="true"
                                        [userCanViewAirspaceAuthorisation]="
                                            userCanViewAirspaceAuthorisation
                                        "
                                        [userCanRequestAirspaceAuthorisation]="
                                            false
                                        "
                                        (showAirspaceAuthorisation)="
                                            showAirspaceAuthorisation()
                                        "
                                        (cancelAirspaceAuthorisation)="
                                            cancelAirspaceAuthorisation($event)
                                        "
                                        (requestNewAirspaceAuthorisation)="
                                            requestNewAirspaceAuthorisation(
                                                $event
                                            )
                                        "
                                    ></airspace-authorisation-status>
                                </div>
                            </tab>
                            <tab
                                *ngIf="
                                    (hasIncidentReports &&
                                        mission.status === 'COMPLETED') ||
                                    mission.status === 'FINALISED'
                                "
                                heading="Incident Reports"
                            >
                                <plan-highlight
                                    [featureFlags]="[
                                        featureFlags['hasIncidentReports']
                                    ]"
                                ></plan-highlight>
                                <incident-report-list
                                    class="top-buffer container-padding"
                                    [missionId]="mission.id"
                                    [timeZone]="mission.timeZone"
                                    [organisationId]="mission.organisationId"
                                    [canAdd]="true"
                                >
                                </incident-report-list>
                            </tab>
                            <tab
                                *ngIf="
                                    currentOrganisation != null &&
                                    mission != null &&
                                    (mission.status === 'COMPLETED' ||
                                        mission.status === 'FINALISED')
                                "
                                heading="Conformance"
                            >
                                <flight-conformance-details
                                    [mission]="mission"
                                    [organisationId]="currentOrganisation.id"
                                    (refreshRibbon)="refreshRibbon()"
                                ></flight-conformance-details>
                            </tab>
                            <tab
                                *ngIf="
                                    mission.missionWorkflowVersion
                                        ?.delegatedAuthority != null
                                "
                                heading="Authority Library"
                            >
                                <authority-library
                                    class="top-buffer container-scroll"
                                    [organisationId]="mission.organisationId"
                                    [mission]="mission"
                                >
                                </authority-library>
                            </tab>
                            <tab *ngIf="true" heading="Situational Awareness">
                                <!-- No relevant information banner -->
                                <div
                                    *ngIf="
                                        !canShowNotams &&
                                        !canShowLotams &&
                                        !mission?.missionSiteList?.length > 0 &&
                                        !mission?.missionOverlapList?.length > 0
                                    "
                                    class="alert alert-info"
                                >
                                    No relevant situational awareness data to
                                    display.
                                </div>
                                <!-- NOTAMs Section -->
                                <ng-container *ngIf="canShowNotams">
                                    <h4 class="section-heading">
                                        <button
                                            *ngIf="canManageNotams"
                                            type="button"
                                            class="btn-circle text-center"
                                            tooltip="Add NOTAM"
                                            placement="top"
                                            [disabled]="
                                                working || isAddingNotams
                                            "
                                            (click)="showNotamSearch()"
                                        >
                                            <span class="fa fa-plus"></span>
                                        </button>
                                        <span>NOTAMs</span>
                                        <div></div>
                                    </h4>
                                    <plan-highlight
                                        [featureFlags]="[
                                            featureFlags['canUseNotams']
                                        ]"
                                    ></plan-highlight>
                                    <ng-container
                                        *ngIf="mission.notams.length > 0"
                                    >
                                        <div
                                            *ngFor="let notam of mission.notams"
                                            class="top-buffer"
                                        >
                                            <notam-details
                                                [notam]="notam"
                                                [listOnly]="true"
                                                [isExpanded]="true"
                                                [disableActions]="
                                                    !canManageNotams
                                                "
                                                [viewNotamDetailModal]="
                                                    viewNotamDetailModal
                                                "
                                                (deleteNotam)="
                                                    removeSearchNotam(notam)
                                                "
                                            ></notam-details>
                                        </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="
                                            mission.notams.length === 0 &&
                                            mission.noNotamDeclarationPerson !=
                                                null
                                        "
                                    >
                                        <div class="alert alert-info">
                                            No relevant NOTAMs. Declared by
                                            {{
                                                mission.noNotamDeclarationPerson
                                                    | formatPerson
                                            }}
                                            at
                                            {{
                                                mission.noNotamDeclarationTime
                                                    | formatDateTime
                                                        : mission.timeZone
                                            }}
                                        </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="
                                            canManageNotams &&
                                            mission.notams.length === 0 &&
                                            mission.noNotamDeclarationPerson ==
                                                null
                                        "
                                    >
                                        <div class="alert alert-info">
                                            No NOTAMs have been added to this
                                            mission.
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <!-- Attached Sites Section -->
                                <ng-container
                                    *ngIf="mission?.missionSiteList?.length > 0"
                                >
                                    <h4 class="section-heading">
                                        <span>Attached Sites</span>
                                        <div></div>
                                    </h4>
                                    <div class="vertical-container">
                                        <div
                                            *ngFor="
                                                let item of mission.missionSiteList
                                            "
                                        >
                                            <span>{{ item.site.name }}</span>
                                            <span
                                                *ngIf="item.site.description"
                                                class="left-buffer text-muted"
                                            >
                                                — {{ item.site.description }}
                                            </span>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- LOTAMs Section -->
                                <ng-container *ngIf="canShowLotams">
                                    <h4 class="section-heading">
                                        <span>LOTAMs</span>
                                        <div></div>
                                    </h4>
                                    <div
                                        *ngFor="
                                            let item of mission.missionNoticeList
                                        "
                                    >
                                        <div class="horizontal-container">
                                            <mission-lotam-summary
                                                style="flex: 1"
                                                [lotam]="item.notice"
                                                [acknowledgementList]="
                                                    item.acknowledgementList
                                                "
                                                [missionId]="mission.id"
                                                [missionLocation]="
                                                    mission.location
                                                "
                                                [organisation]="organisation"
                                                [missionCrew]="missionCrew"
                                                [isReadOnly]="
                                                    mission.status !== 'DRAFT'
                                                "
                                                [status]="item.status"
                                            >
                                            </mission-lotam-summary>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- Conflicting Missions Section -->
                                <ng-container
                                    *ngIf="
                                        mission?.missionOverlapList?.length > 0
                                    "
                                >
                                    <h4 class="section-heading">
                                        <span>Conflicting Missions</span>
                                        <div></div>
                                    </h4>
                                    <div class="vertical-container">
                                        <div
                                            *ngFor="
                                                let item of mission.missionOverlapList
                                            "
                                        >
                                            <mission-overlap-summary
                                                style="flex: 1"
                                                [overlappingMission]="
                                                    item.overlappingMission
                                                "
                                                [acknowledgementList]="
                                                    item.acknowledgementList
                                                "
                                                [mission]="mission"
                                                [organisationId]="
                                                    organisation.id
                                                "
                                                [locationFeatures]="
                                                    locationFeatures ?? []
                                                "
                                                [overlapStatus]="item.status"
                                            >
                                            </mission-overlap-summary>
                                        </div>
                                    </div>
                                </ng-container>
                            </tab>
                            <!-- <tab
                                *ngIf="
                                    mission?.airspaceAuthorisationList?.length >
                                        0 &&
                                    mission.airspaceAuthorisationList[
                                        mission.airspaceAuthorisationList
                                            .length - 1
                                    ].authorisationType ==
                                        'AUS_CASA_AUTHORISATION'
                                "
                                heading="CASA Authorisation"
                            >
                                <div class="relative" style="height: 280px">
                                    <airspace-authorisation-status
                                        [checkingAuthorisation]="
                                            checkingAuthorisation
                                        "
                                        [canDoAirspaceAuthorisation]="
                                            canDoAirspaceAuthorisation
                                        "
                                        [areAuthorisationRequirementsComplete]="
                                            areAuthorisationRequirementsComplete
                                        "
                                        [airspaceCheckCanFly]="
                                            airspaceCheckCanFly
                                        "
                                        [approvedAirspaceAuthorisation]="
                                            approvedAirspaceAuthorisation
                                        "
                                        [airspaceApprovalState]="
                                            airspaceApprovalState
                                        "
                                        (showAirspaceAuthorisation)="
                                            showAirspaceAuthorisation()
                                        "
                                        (requestNewAirspaceAuthorisation)="
                                            requestNewAirspaceAuthorisation()
                                        "
                                        (cancelAirspaceAuthorisation)="
                                            cancelAirspaceAuthorisation()
                                        "
                                        (closeAirspaceAuthorisation)="
                                            closeAirspaceAuthorisation()
                                        "
                                    ></airspace-authorisation-status>
                                </div>
                            </tab> -->
                        </tabset>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-5 top-buffer">
                        <h4 class="section-heading">
                            <span>Workflow Documentation</span>
                            <div></div>
                        </h4>
                        <p>
                            These are the forms that have been filled in before
                            and after the mission.
                        </p>
                        <ng-container *ngIf="documentation">
                            <documentation-list
                                [organisationId]="currentOrganisation.id"
                                [formResponses]="documentation.formResponses"
                                [requiredDocumentation]="
                                    documentation.requiredDocumentation
                                "
                                [steps]="missionDocumentationSteps"
                                [title]="'Mission'"
                                [requiringEntities]="requiringEntities"
                                [requiringEntitySourceLookup]="
                                    requiringEntitySourceLookup
                                "
                                [documentationActions]="documentationActions"
                                [attachmentsHandler]="attachmentsHandler"
                                [missionRequiredDocumentation]="
                                    documentation.requiredDocumentation
                                "
                                [missionApprovalList]="mission?.approvals"
                            >
                            </documentation-list>
                        </ng-container>
                    </div>
                    <div class="col-md-7 top-buffer">
                        <h4 class="section-heading">
                            <span>Attached Documents</span>
                            <div></div>
                        </h4>
                        <attachment-list
                            *ngIf="attachmentsHandler"
                            [attachmentsHandler]="attachmentsHandler"
                            [allowUploads]="canEdit"
                            [allowDelete]="false"
                            [allowEdit]="canEdit"
                            [parentPromiseTracker]="workTracker"
                            (isEditing)="isEditingAttachments = $event"
                            permissions
                        >
                        </attachment-list>
                    </div>
                    <div class="col-xs-12 top-buffer">
                        <accordion
                            *ngIf="
                                mission != null && mission.approvals.length > 0
                            "
                            class="inline-section"
                            [closeOthers]="true"
                        >
                            <accordion-group
                                (isOpenChange)="
                                    $event ? (opened = true) : (opened = false)
                                "
                            >
                                <div accordion-heading>
                                    <div
                                        class="pull-right"
                                        tooltip="Historical approvals"
                                    >
                                        <span
                                            class="pull-right glyphicon"
                                            [ngClass]="{
                                                'glyphicon-chevron-down':
                                                    opened,
                                                'glyphicon-chevron-right':
                                                    !opened
                                            }"
                                        ></span>
                                    </div>
                                    Approval History
                                </div>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Approval ID</th>
                                            <th>Submission time</th>
                                            <th>Approval status</th>
                                            <th>Message</th>
                                            <th>Documentation</th>
                                            <th>Conditions</th>
                                            <th style="width: 5%"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="
                                                let approval of mission.approvals
                                            "
                                        >
                                            <td>{{ approval.id }}</td>
                                            <td>
                                                {{
                                                    approval.requestTime
                                                        | formatDateTime
                                                            : mission.timeZone
                                                }}
                                                <br />
                                                <span
                                                    ><em>{{
                                                        approval.requestedBy
                                                            | formatPerson
                                                    }}</em></span
                                                >
                                            </td>
                                            <td>
                                                {{
                                                    approval.status
                                                        | formatApprovalStatus
                                                }}
                                                <span
                                                    *ngIf="
                                                        isResolved(
                                                            approval.status
                                                        )
                                                    "
                                                >
                                                    <em>{{
                                                        approval.approvedBy
                                                            | formatPerson
                                                    }}</em>
                                                    {{
                                                        approval.resolutionTime
                                                            | formatDateTime
                                                                : mission.timeZone
                                                    }}
                                                </span>
                                            </td>
                                            <td class="pre-line">
                                                {{
                                                    approval.messageFromApprover
                                                }}
                                                <br />
                                            </td>
                                            <td>
                                                <!--                                    <completed-documentation-->
                                                <!--                                            organisation-id="$ctrl.currentOrganisation.id"-->
                                                <!--                                            form-responses="$ctrl.documentation.formResponses"-->
                                                <!--                                            required-documentation="$ctrl.approvalRequiredDocumentation[approval.id]"-->
                                                <!--                                            steps="$ctrl.approvalSteps"-->
                                                <!--                                            title="Mission Approval"-->
                                                <!--                                            requiring-entities="[{requiringEntityType: 'MissionApproval', requiringEntityId: approval.id}]">-->
                                                <!--                                    </completed-documentation>-->
                                            </td>
                                            <td>
                                                <ol>
                                                    <li
                                                        *ngFor="
                                                            let condition of approval.conditions
                                                        "
                                                    >
                                                        {{ condition }}
                                                    </li>
                                                </ol>
                                            </td>
                                            <td>
                                                <div
                                                    class="horizontal-container"
                                                    style="justify-content: end"
                                                >
                                                    <button
                                                        class="btn btn-primary btn-sm right-buffer"
                                                        type="button"
                                                        *ngIf="
                                                            canPrepareToFly &&
                                                            allowEditSubmit &&
                                                            approval.status ===
                                                                'DRAFT'
                                                        "
                                                        (click)="
                                                            submitForApproval(
                                                                approval
                                                            )
                                                        "
                                                        [disabled]="working"
                                                    >
                                                        Submit
                                                    </button>
                                                    <button
                                                        class="btn btn-default-action btn-sm right-buffer"
                                                        type="button"
                                                        *ngIf="
                                                            canPrepareToFly &&
                                                            allowEditSubmit &&
                                                            (approval.status ===
                                                                'DRAFT' ||
                                                                approval.status ===
                                                                    'PENDING')
                                                        "
                                                        (click)="
                                                            cancelApproval(
                                                                approval
                                                            )
                                                        "
                                                        [disabled]="working"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        class="btn btn-primary btn-sm"
                                                        type="button"
                                                        tooltip="View or perform the mission approval"
                                                        placement="top"
                                                        *ngIf="
                                                            canApprove &&
                                                            (combinedStatus !==
                                                                'DRAFT' ||
                                                                (missionApprovals &&
                                                                    missionApprovals.length >
                                                                        1)) &&
                                                            approval.status !==
                                                                'CANCELLED' &&
                                                            approval.status !==
                                                                'DRAFT'
                                                        "
                                                        [disabled]="working"
                                                        (click)="
                                                            findApprovalAndApprove(
                                                                approval
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            approval.status ===
                                                                'PENDING' ||
                                                            approval.status ===
                                                                'BEING_REVIEWED'
                                                                ? 'Perform'
                                                                : 'View'
                                                        }}
                                                        Approval
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </accordion-group>
                        </accordion>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="modal-footer">
            <div *ngIf="missionDetails != null && modalStatus === 'LOADED'">
                <div
                    *ngIf="printOptions.length > 0"
                    class="btn-group"
                    dropdown
                    [dropup]="true"
                >
                    <button
                        class="btn btn-default dropdown-toggle"
                        dropdownToggle
                        type="button"
                        aria-controls="dropdown-container"
                        [disabled]="working"
                    >
                        Reports
                        <span class="caret"></span>
                    </button>
                    <ul
                        *dropdownMenu
                        class="dropdown-menu dropdown-menu-right modal-dropdown"
                        role="menu"
                    >
                        <li *ngFor="let option of printOptions" role="menuitem">
                            <a (click)="option.print()">{{ option.name }}</a>
                        </li>
                    </ul>
                </div>
                <button
                    *ngIf="canCancel"
                    class="btn btn-default pull-left"
                    type="button"
                    (click)="cancelMission()"
                    [disabled]="working || hasPendingApproval()"
                    tooltip="Cancel the mission"
                    placement="top"
                >
                    Cancel Mission
                </button>
                <button
                    *ngIf="canDelete"
                    class="btn btn-danger pull-left"
                    type="button"
                    (click)="deleteMission()"
                    [disabled]="working"
                    tooltip="Delete the mission"
                    placement="top"
                >
                    Delete Mission
                </button>
                <button
                    *ngIf="hasFinalise && mission.status === 'COMPLETED'"
                    type="button"
                    class="btn btn-default"
                    [disabled]="working"
                    (click)="updateFilingFields()"
                >
                    Update Filing Fields
                </button>
                <button
                    *ngIf="canUnfinalise && mission.status === 'FINALISED'"
                    class="btn btn-primary"
                    type="button"
                    [disabled]="working"
                    (click)="unfinaliseMission()"
                >
                    Unfinalise Mission
                </button>
                <button
                    *ngIf="canComplete && mission.status === 'READY_TO_FLY'"
                    class="btn btn-primary"
                    type="button"
                    [disabled]="working || isEditingAttachments"
                    (click)="openMissionCompletionDialogue()"
                    tooltip="Enter the details of what happened during the mission"
                    placement="top"
                >
                    Create Mission Record
                </button>
                <button
                    *ngIf="
                        canComplete &&
                        mission.status === 'COMPLETED' &&
                        mission.type !== 'RETROSPECTIVE'
                    "
                    class="btn btn-primary"
                    type="button"
                    [disabled]="working || isEditingAttachments"
                    (click)="openMissionCompletionDialogue()"
                    tooltip="Make amendments to the finished mission"
                    placement="top"
                >
                    Edit Mission Record
                </button>
                <button
                    *ngIf="canComplete && mission.type === 'RETROSPECTIVE'"
                    class="btn btn-primary"
                    type="button"
                    [disabled]="working || isEditingAttachments"
                    (click)="openMissionRecordDialogue()"
                    tooltip="Make amendments to the retrospective mission"
                    placement="top"
                >
                    Edit Mission Record
                </button>
                <button
                    *ngIf="
                        allowEditSubmit &&
                        canEdit &&
                        mission.type !== 'RETROSPECTIVE'
                    "
                    class="btn btn-primary"
                    type="button"
                    [disabled]="working || isEditingAttachments"
                    (click)="editMission()"
                >
                    Edit Mission Plan
                </button>
                <button
                    *ngIf="
                        canApprove &&
                        combinedStatus !== 'DRAFT' &&
                        combinedStatus !== 'SUBMITTED' &&
                        activeMissionApprovals &&
                        activeMissionApprovals.length > 1
                    "
                    class="btn btn-primary"
                    type="button"
                    [disabled]="working || isEditingAttachments"
                    #approvalSelectionPopover="bs-popover"
                    [popover]="approvalSelectionPopTemplate"
                    container=""
                    [outsideClick]="true"
                    [adaptivePosition]="true"
                    placement="top"
                >
                    {{ combinedStatus === 'SUBMITTED' ? 'Perform' : 'View' }}
                    Approval
                </button>
                <button
                    *ngIf="
                        canApprove &&
                        combinedStatus !== 'DRAFT' &&
                        activeMissionApprovals &&
                        (activeMissionApprovals.length === 1 ||
                            combinedStatus === 'SUBMITTED')
                    "
                    class="btn btn-primary"
                    type="button"
                    tooltip="View or perform the mission approval"
                    placement="top"
                    [disabled]="working || isEditingAttachments"
                    (click)="approveMission(activeMissionApprovals[0])"
                >
                    {{ combinedStatus === 'SUBMITTED' ? 'Perform' : 'View' }}
                    Approval
                </button>
                <button
                    *ngIf="
                        combinedStatus !== 'DRAFT' &&
                        canAcceptApproval &&
                        missionApprovals &&
                        missionApprovals.length === 1
                    "
                    class="btn btn-primary"
                    type="button"
                    tooltip="View or perform the mission approval"
                    placement="top"
                    [disabled]="working || isEditingAttachments"
                    (click)="acceptApproval(missionApprovals[0])"
                >
                    Accept Approval
                </button>
                <button
                    *ngIf="
                        combinedStatus !== 'DRAFT' &&
                        canAcceptApproval &&
                        missionApprovals &&
                        missionApprovals.length > 1
                    "
                    class="btn btn-primary"
                    type="button"
                    tooltip="View or perform the mission approval"
                    placement="top"
                    [disabled]="working || isEditingAttachments"
                    #approvalSelectionPopover="bs-popover"
                    [popover]="approvalSelectionPopTemplate"
                    container=""
                    [outsideClick]="true"
                    [adaptivePosition]="true"
                    placement="top"
                >
                    Accept Approvals
                </button>
            </div>
        </div>
    </form>
    <inline-modal
        #viewNotamDetailModal
        [sizeSmall]="true"
        style="max-height: fit-content"
    >
    </inline-modal>
    <inline-modal [show]="isAddingNotams"
        ><notam-search
            *ngIf="isAddingNotams && canUseNotams && canManageNotams"
            [existingAerodromes]="existingAerodromes"
            [existingNotams]="missionNotams"
            [locationJurisdiction]="locationJurisdiction"
            [missionId]="mission.id"
            [hasAcknowledgedNoRelevantNotams]="
                mission.noNotamDeclarationTime != null
            "
            (close)="hideNotamSearch()"
            (addNotam)="addAerodromeNotam($event)"
            (removeNotam)="removeSearchNotam($event)"
            (acknowledgeNoRelevantNotam)="acknowledgeNoRelevantNotam()"
            [location]="mission.location"
        ></notam-search
    ></inline-modal>
</ng-container>

<ng-template #approvalSelectionPopTemplate>
    <mission-approval-selection-popup
        [approvals]="missionApprovals"
        [organisation]="organisation"
        [canApprove]="canApprove"
        [canAcceptApproval]="canAcceptApproval"
        [timeZone]="mission.timeZone"
        (viewApproval)="approveMission($event)"
        (acceptApproval)="acceptApproval($event)"
        (cancel)="approvalSelectionPopover.hide()"
    ></mission-approval-selection-popup>
</ng-template>
